<div data-at-installation-list id="installation-list" class="flex flex-col">
  <div data-at-head class="head flex flex-col">
    <div
      data-at-headline
      class="headline flex flex-row justify-start items-center lt-md:items-start lt-md:flex-auto"
    >
      <div class="search-wrapper">
        <ng-content select="[search]"></ng-content>
      </div>
    </div>
  </div>
  <div data-at-body class="body flex flex-col flex-auto">
    <ng-content select="[installation-item]"></ng-content>
    <ng-content select="[no-results]"></ng-content>
  </div>
  <div data-at-foot class="foot flex flex-col flex-auto">
    <ng-content select="[paginator]"></ng-content>
  </div>
</div>
